import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import Dot from "@Front/Components/Layouts/Legal/LegalInformations/elements/Dot";
import { useDeploymentLineLegalPublisher } from "@Front/Services/DeploymentLineLegalPublisher/DeploymentLineLegalPublisherContext";

export function CGUSection9(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				9. Responsabilité de {pub.publisherLegalName}
			</Typography>
		</section>
	);
}

function CGUSection9_1Tail(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				La responsabilité de {pub.publisherLegalName} ne pourra être engagée sur le fondement d&apos;une garantie de délai de traitement des échanges
				dématérialisés.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				{pub.publisherLegalName} est un prestataire technique mettant en œuvre un processus d&apos;échanges et d&apos;archivage dématérialisés de documents
				et de données.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Dans le cas de traitement d&apos;anomalies techniques, {pub.publisherLegalName} peut être amenée à analyser les aspects techniques contenus
				dans les flux à l&apos;exception de tout autre aspect tenant notamment à la validité de l&apos;opération réalisée, aux effets
				juridiques liés à l&apos;opération, etc.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Dans l&apos;hypothèse où la responsabilité de {pub.publisherLegalName} se trouverait engagée, pour quelque cause que ce soit, au titre des
				présentes conditions, la responsabilité de {pub.publisherLegalName} est expressément limitée la sécurisation des données qui lui ont été
				transmises par les utilisateurs, professionnels ou non, à l&apos;exclusion de tous dommages indirects (notamment dommages
				commerciaux et moraux, perte de chiffre d&apos;affaires, perte de clientèle) qui seront exclus de la réparation due par
				{pub.publisherLegalName}.
			</Typography>
		</>
	);
}

export function CGUSection9_1(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<section>
			<Typography typo={ETypo.TEXT_LG_REGULAR} color={ETypoColor.TEXT_ACCENT}>
				9.1. Responsabilité générale
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				La responsabilité de {pub.publisherLegalName} ne pourra pas être retenue en cas de non-compatibilité du système d&apos;information de l&apos;Office
				avec les Services proposés.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Pour des raisons de maintenance, ou du fait de tiers, l&apos;accès et le fonctionnement, partiel ou total des Services
				{pub.publisherLegalName}, pourront être suspendus, sans que cette interruption puisse ouvrir droit à une quelconque indemnité au bénéfice
				de l&apos;Office ou de tout tiers ou constituer une cause de résiliation.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				En cas d&apos;interruption des Services {pub.publisherLegalName}, l&apos;éditeur mettra tous les moyens nécessaires en œuvre pour rétablir le plus
				rapidement possible l&apos;accès aux services, sauf si l&apos;interruption résulte d&apos;un défaut qui ne lui est pas imputable.
			</Typography>
			<CGUSection9_1Tail />
		</section>
	);
}

export function CGUSection9_2(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<section>
			<Typography typo={ETypo.TEXT_LG_REGULAR} color={ETypoColor.TEXT_ACCENT}>
				9.2. Responsabilité à l&apos;égard des informations présentes sur le Site
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				{pub.publisherLegalName} fait ses meilleurs efforts pour proposer sur son Site des informations à jour.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Toutes les informations portées à la connaissance des personnes accédant au Site ont été sélectionnées à une date
				déterminée. Compte tenu de la nature et de la complexité des technologies qui sont mises en œuvre, chaque Partie reconnaît
				que le Site ne peut être exempte d&apos;Anomalies, de défaillances, d&apos;interruptions et d&apos;indisponibilités.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				En cas de dysfonctionnement ou d&apos;incident de quelque nature que ce soit lors de l&apos;utilisation du Site, l&apos;Internaute doit en
				informer immédiatement {pub.publisherLegalName}.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				{pub.publisherLegalName} ne saurait être tenue responsable de toute erreur ou omission.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Toute mise à jour, nouvelle prestation ou nouvelle caractéristique qui améliore ou augmente un ou plusieurs contenus
				d&apos;informations existants sera soumis aux présentes conditions.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Les équipements (notamment ordinateur, téléphone, logiciels, moyens de communication électronique) permettant l&apos;accès et
				l&apos;utilisation au Site sont à la charge exclusive des Internautes, de même que les frais de communications électroniques
				(notamment coûts téléphoniques, coûts d&apos;accès à Internet) résultant de leur utilisation.
			</Typography>
		</section>
	);
}

export function CGUSection10(): React.JSX.Element {
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				10. Responsabilités de l&apos;Internaute
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Dans le cadre des présentes CGU, l&apos;Internaute a été informé qu&apos;il devait s&apos;assurer :
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				<Dot>du respect des préconisations techniques requises ;</Dot>
				<Dot>qu&apos;il dispose de la compétence nécessaire et des informations suffisantes pour une utilisation optimale du Site.</Dot>
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute demeure intégralement et exclusivement responsable de l&apos;exploitation des informations obtenues sur le
				Site.{" "}
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				De manière générale, chaque Internaute s&apos;engage à utiliser le Site :{" "}
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				<Dot>dans le respect des lois, réglementation et droits des tiers ;</Dot>
				<Dot>de manière loyale et conformément à sa destination, dans le respect des présentes CGU et de la Réglementation.</Dot>
			</Typography>
		</section>
	);
}

export function CGUSection11(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				11. Obligations de l&apos;Internaute
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute s&apos;engage à n&apos;utiliser le Site ainsi que l&apos;ensemble des informations auxquelles il pourra avoir accès que pour
				obtenir des informations et dans un but conforme à l&apos;ordre public, aux bonnes mœurs et aux droits des tiers.{" "}
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Ainsi, il lui est interdit de publier ou de transmettre via le Site tout élément illicite, préjudiciable, diffamatoire,
				pornographique, haineux, raciste ou autrement attentatoire à la dignité humaine notamment. Au cas où {pub.publisherLegalName} serait
				informé de la présence de contenus illicites sur le Site, {pub.publisherLegalName} serait en droit d&apos;en supprimer immédiatement le
				contenu et empêcher l&apos;accès au Site à l&apos;Internaute.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute s&apos;engage, par ailleurs, à ne pas perturber l&apos;usage que pourraient faire les autres Internautes du Site de ne
				pas accéder à des Parties du Site dont l&apos;accès est réservé.
			</Typography>
		</section>
	);
}

export function CGUSection12(): React.JSX.Element {
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				12. Propriété intellectuelle
			</Typography>
		</section>
	);
}
